<template>
  <div>
    <dx-data-grid
      :show-borders="true"
      ref="batch-child-grid"
      :columns="columns"
      :data-source="dataSource"
    >
      <DxSearchPanel :visible="false" />
      <template #use-by-cell-template="{ data }">
        <gc-friendly-date :date="data.data.UseByDate" />
      </template>

      <template #qtyEditTemplate="{ data: cellInfo }">
        <div>
          <div>
            <DxNumberBox
              :value="cellInfo.value"
              @value-changed="onQuantityChanged($event, cellInfo)"
              class="gc-grid-number-box-editor"
              :format="getDecimalFormatByCode(2).Format"
            />
          </div>
        </div>
      </template>

      <DxEditing v-if="isEditable" :allow-updating="true" mode="cell" />
    </dx-data-grid>
  </div>
</template>
<script>
import { DxDataGrid } from "devextreme-vue/data-grid";
import { alert } from "devextreme/ui/dialog";
import BaseViewMixin from "../../src/v1/_mixins/base.view";

export default {
  components: { DxDataGrid },
  props: {
    isEditable: Boolean,
    templateData: {
      type: Object,
      default: () => {},
    },
    parentModel: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    brokenGridValidations: {
      type: Array,
    },
  },
  created() {
    if (this.isEditable && this.dataSource.length == 0)
      this.onAddClickHandler();
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      dataSource: this.templateData.data.GoodsReturnProductBatches,
    };
  },
  computed: {
    noOfRecords() {
      return this.dataSource.length;
    },
  },
  methods: {
    onQuantityChanged(valueChangedArgs, cellInfo) {
      if (valueChangedArgs.value > cellInfo.data.SupplierAvailableQty) {
        let errorMsg = {
          Code: this.templateData.data.ItemCode,
          Description: this.templateData.data.ItemDescription,
          Batch: cellInfo.data.BatchNo,
          ReturnQty: valueChangedArgs.value,
          AvailableQty: cellInfo.data.SupplierAvailableQty,
        };
        const index = this.brokenGridValidations.findIndex(
          (x) =>
            x.Code === this.templateData.data.ItemCode &&
            x.Batch === cellInfo.data.BatchNo
        );
        if (index > -1) {
          this.brokenGridValidations[index] = errorMsg;
        } else {
          this.brokenGridValidations.push(errorMsg);
        }
        this.$nextTick(function() {
          alert(
            `Batch ${cellInfo.data.BatchNo} of item : ${
              this.templateData.data.ItemDescription
            } has a return quantity of ${this.formatNumber(
              valueChangedArgs.value
            )} which is more than the available quantity of ${this.formatNumber(
              cellInfo.data.SupplierAvailableQty
            )}.`,
            "Validation Errors"
          );
        });
      } else {
        const index = this.brokenGridValidations.findIndex(
          (x) =>
            x.Code === this.templateData.data.ItemCode &&
            x.Batch === cellInfo.data.BatchNo
        );
        if (index > -1) {
          this.brokenGridValidations.splice(index, 1);
        }
      }
      if (this.dataSource.length > 0) {
        this.dataSource[cellInfo.rowIndex].SupplierReturnedQty =
          valueChangedArgs.value;
        this.recalculateTotal();
      }
    },

    formatNumber(number) {
      return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },

    recalculateTotal() {
      let totalSupplierBatchReturnQty = 0;
      this.dataSource.forEach((x) => {
        totalSupplierBatchReturnQty += x.SupplierReturnedQty;
      });

      this.templateData.data.SupplierReturnedQty = totalSupplierBatchReturnQty;
    },
  },
  watch: {
    noOfRecords: {
      handler: function(value) {
        // add a record if the no of items in the datasource is 0
        if (this.isEditable && value == 0) {
          this.onAddClickHandler();
        }
      },
    },
  },
};
</script>
<style>
.master-detail-caption {
  padding: 0 0 5px 10px;
  font-size: 14px;
  font-weight: bold;
}
</style>
